import {Component, ElementRef, Input, ViewChild, ComponentRef} from '@angular/core';
import * as THREE from 'three';
import {Dimensions, ShapeService} from './shape.service';
import {FormControl} from '@angular/forms';
import {JsUploadComponent} from './js-upload/js-upload.component';
import {ConstructedProfile, ProfileShape} from "./profile-shape-object";
import {
  ArticleListDataModel,
  ArticleModel,
  EngineType,
  EventModel, InputEventKey,
  ShapeModel,
  USC_LIB_CONFIG
} from "@schuco-vcl/usc-lib";

// ! Testing -- Set to true to test with validated/local files.
const TESTING = false;
const LOCAL_URL = './assets/test-models/validated/article__504080.js';

@Component({
  selector: 'app-model-viewer',
  templateUrl: './model-viewer.component.html',
  styleUrls: ['./model-viewer.component.scss'],
  standalone: false,
  providers: [
    {
      provide: USC_LIB_CONFIG,
      useValue: {
        engineType: EngineType.Article,
      }
    }
  ],
})
export class ModelViewerComponent {
  remoteShapesFnString!: string;
  length = 12;
  width = 8;
  // helperLinesSubscription: Subscription;
  // imageViewerSubscription: Subscription;
  showImageViewer: boolean = false;
  showJsUpload: boolean = false;
  dimensions!: Dimensions;

  canvasInputData: any | null = null;

  // @ViewChild('canvasContainer', {static: false}) canvasContainer!: ElementRef;
  @ViewChild(JsUploadComponent) jsUploadComponent!: ComponentRef<JsUploadComponent>;
  @Input() jsUrl!: string;
  @Input() imageUrl!: string;
  @Input() articleName!: string;
  @Input() helperLinesToggle: FormControl = new FormControl(false);
  @Input() imageViewerToggle: FormControl = new FormControl(false);

  constructor(
    private shapeService: ShapeService
  ) {
    // this.helperLinesSubscription = this.helperLinesToggle.valueChanges.subscribe((value) => {
    //   this.onToggleHelperLinesChange(value);
    // });
    //
    // this.imageViewerSubscription = this.imageViewerToggle.valueChanges.subscribe((value) => {
    //   this.showImageViewer = value;
    //   setTimeout(() => {
    //     this.updateDimensions();
    //     this.canvasContainer.nativeElement.addEventListener(
    //       'resize', () => this.updateDimensions()
    //     );
    //   });
    // });
  }

  ngAfterViewInit() {
    this.calculateDimensions();
    this.setupScene();
  }

  /**
   * Initializes the scene, retrieves the shapes from the remote js file, and renders the scene.
   */
  private setupScene() {
    // this.shapeService.initScene(this.canvasContainer.nativeElement, this.dimensions);

    let jsUrlToPassIn: string;
    if (TESTING) {
      jsUrlToPassIn = LOCAL_URL;
    } else {
      jsUrlToPassIn = this.jsUrl;
    }

    this.extractFunctionNameFromUrl(jsUrlToPassIn); // Allows for calling of remote function
    const articles: ArticleModel[] = [];

    this.shapeService.getRemoteJs(jsUrlToPassIn).subscribe({
      next: (data: any) => {
        // ! Would be better to have backend return json or glb file, this executes any JS returned.
        // ! We will have minimal, future-improved authentication so nobody should be able to execute malicious code,
        // ! But it's still not ideal

        const profileShapes: ProfileShape[] = [];
        const articleObject = this.getArticleObject(data);
        console.log(articleObject);
        (articleObject.shapes as THREE.Shape[]).forEach(shape => {
          profileShapes.push(ProfileShape.createObj(shape));
        });
        articleObject.shapes = profileShapes;
        const constructedProfile = ConstructedProfile.createObj(articleObject);
        const shapes: ShapeModel[] = [];
        constructedProfile.profileShapes.forEach((shapeObj: ProfileShape) => {
          shapes.push(ShapeModel.createObjFromShape(shapeObj.shape, shapeObj.useMaterial));
        });

        const article = ArticleModel.createObj(constructedProfile.articleName, constructedProfile.system, constructedProfile.type,
          constructedProfile.depth, constructedProfile.width, constructedProfile.insideWidth, constructedProfile.outsideWidth, shapes
        );
        articles.push(article);

        const eventData = ArticleListDataModel.createDataModel([]);
        this.canvasInputData = EventModel.createEvent(InputEventKey.SetArticles, eventData);


        // const meshes = this.shapeService.getMeshes(articleShapes);
        // this.shapeService.addToScene(meshes);
        // this.shapeService.renderScene();
        // this.updateDimensions();
        // this.canvasContainer.nativeElement.addEventListener(
        //   'resize', () => this.updateDimensions()
        // );
      },
      error: (error: any) => {
        console.error("Shapes could not be retrieved from the remote file.")
      }
    });
  }

  /**
   * Calculates the dimensions of the canvas container.
   */
  private calculateDimensions() {
    // this.dimensions = {
    //   containerWidth: this.canvasContainer.nativeElement.clientWidth,
    //   containerHeight: this.canvasContainer.nativeElement.clientHeight
    // }
  }

  /**
   * Calculates and applies them as needed in the service.
   */
  private updateDimensions() {
    this.calculateDimensions();
    // this.shapeService.updateDimensions(this.dimensions);
  }

  /**
   * Toggles the helper lines on and off.
   * @param value boolean value of the toggle
   */
  private onToggleHelperLinesChange(value: boolean) {
    // Pass the value to your service
    // this.shapeService.setHelperLinesValue(value);
  }

  /**
   * Renders the JsUploadComponent.
   */
  public onClickJsUpload() {
    this.showJsUpload = true;
  }

  /**
   * Removes the JsUploadComponent, resets its values, and re-renders the scene.
   */
  public refreshJsUploadComponent() {
    this.showJsUpload = false;
    // this.shapeService.clearScene();
    this.setupScene();
  }

  ngOnDestroy() {
    // Clean up the subscription to avoid memory leaks
    // this.helperLinesSubscription.unsubscribe();
  }

  /**
   * Parses the three.js url for article name so that it's article function can be called.
   * @param url url of remote js file
   */
  private extractFunctionNameFromUrl(jsUrl: string) {
    //this.remoteShapesFnString = jsUrl.split('/').pop()?.replace(/\.[^/.]+$/, '').replace(/[^a-zA-Z0-9_]/g, '') + '()';
    this.remoteShapesFnString = jsUrl.split('/').pop()?.replace(/\.[^/.]+$/, '').replace(/\./g, '_') + '()';

  }

  /**
   * Executes the remote JS file and sets its return as the article object.
   * @param data the remote js file, return of getRemoteJs()
   * @returns the article object from the remote js file's function
   */
  private getArticleObject(data: any) {
    const fixedFnCode = data.replace('function ' + this.remoteShapesFnString, '(THREE) =>')
    // Using Function constructor instead of eval for better security
    const functionFromFile = new Function('return ' + fixedFnCode)();
    return functionFromFile(THREE);
  }
}
